import { TableRow as MUITableRow } from '@mui/material';
import { memo } from 'react';

import { Checkbox, TableBodyCell, TableCellDate } from '../../Shared';
import { TableCellDetails } from './TableCellDetails';

export const TableRow = memo(({ callLog, isRowChecked, onSelectRow }) => {
  return (
    <MUITableRow>
      <TableBodyCell width="48px">
        <Checkbox
          color="primary"
          checked={isRowChecked}
          onChange={() => {
            onSelectRow(callLog.callRecordingID);
          }}
          size="xl"
        />
      </TableBodyCell>
      <TableBodyCell>{callLog.tenant}</TableBodyCell>
      <TableBodyCell>{callLog.callerName}</TableBodyCell>
      <TableBodyCell className="max-w-60">
        {callLog.contactCompany}
      </TableBodyCell>
      <TableBodyCell>{callLog.contactName}</TableBodyCell>
      <TableBodyCell>{callLog.phoneNumber}</TableBodyCell>
      <TableCellDate date={callLog.createdAt} />
      <TableBodyCell>{callLog.callDuration}</TableBodyCell>
      <TableBodyCell>{callLog.callOutcome || '-'}</TableBodyCell>
      <TableCellDetails
        callRecordingID={callLog.callRecordingID}
        contactName={callLog.contactName}
        contactCompany={callLog.contactCompany}
        tenant={callLog.tenant}
      />
    </MUITableRow>
  );
});
TableRow.displayName = 'TableRow';
